import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {environment as env} from '../../../../environments/environment';

@Component({
    selector: 'sd-verify-phone',
    templateUrl: './verify-phone.component.html'
})
export class VerifyPhoneComponent implements OnInit {
    message;
    code;
    phone;
    requestPhone = false;
    error;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public httpClient: HttpClient
    ) {
    }

    ngOnInit() {
        let user = JSON.parse(localStorage.getItem('User'));

        if (user.phone && user.phone_verified == false) {
            this.phone = user.phone;
            // this.request();
        }
    }

    checkPhone() {
        let user = JSON.parse(localStorage.getItem('User'));

        if (this.phone == user.phone && user.phone_verified == true) {
            this.error = 'Số điện thoại đã được xác thực.';
            this.clearError();
            return false;
        }

        return true;
    }

    getRedirectUrl() {
        let url = '/';
        let queryUrl = this.route.snapshot.queryParamMap.get('continue');
        
        if (queryUrl) {
            url = queryUrl;
        }

        return url;
    }

    confirmOtp() {
        this.httpClient.post(`${env.apiIcheck}/account/next`, {phone: this.phone, code: this.code}, {headers: this.headers()})
            .subscribe(
                (res: any) => {
                    if (res.status != 200) {
                        this.error = 'Mã otp không chính xác hoặc số điện thoại đã được xác thực. kiểm tra tin nhắn và thử lại.';
                        this.clearError();
                    } else {
                        let user = JSON.parse(localStorage.getItem("User"));

                        user.phone = this.phone;
                        user.phone_verified = true;

                        localStorage.setItem("User", JSON.stringify(user));

                        this.router.navigate([this.getRedirectUrl()]);
                    }
                },
                (err) => {
                    this.error = 'Mã otp không chính xác. kiểm tra tin nhắn và thử lại.';
                    this.clearError();
                }
            );
    }

    clearError() {
        setTimeout(() => {
            this.error = '';
        }, 3000);
    }

    request() {

        if (!this.checkPhone()) {
            return;
        }

        let token = this.getToken();
        // this.requestPhone = true;
        this.httpClient
            .post(`${env.apiIcheck}/account/next`, {phone: this.phone}, {headers: this.headers()})
            .subscribe(() => {
                this.requestPhone = true;
            });
    }

    headers() {
        return new HttpHeaders().set('Access-Token', this.getToken());
    }

    getToken() {
        return localStorage.getItem('Access-Token-Icheck');
    }
}


// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/verify-phone.component.ts